import { IDepartmentInfo } from '../models/tenant-user-access.model';

export function isModulePaused(
  department: IDepartmentInfo | undefined | null,
  moduleNumber: number | undefined | null
): boolean {
  if (!department?.pause?.isPaused || moduleNumber == null) {
    return false;
  }

  return department.pause.modules?.some((module) => module === moduleNumber) ?? false;
}
